import { AutoRegisterPutRequest } from '@syf-api-library/auto-register'
import { Account } from '@syf-api-library/credit-accounts'

const getAutoRegisterPayload = (
  accounts: Account[]
): AutoRegisterPutRequest[] => {
  const autoRegistrationPayload: AutoRegisterPutRequest[] = []

  accounts.forEach((account) => {
    const {
      registration: {
        registered,
        eligibleForAutoRegistration,
        transferable,
        registeredByVirtueOf
      },
      product: { lineOfBusiness }
    } = account
    if (!registered && (eligibleForAutoRegistration || transferable)) {
      autoRegistrationPayload.push({
        targetAccountId: account.info['cipher.accountId'],
        eligibleForAutoRegistration,
        registered,
        registeredAccountId: registeredByVirtueOf,
        transferable,
        lineOfBusiness
      })
    }
  })
  return autoRegistrationPayload
}

export default getAutoRegisterPayload
